require('bootstrap/js/src/collapse');

exports.onRouteUpdate = ({ location, prevLocation }) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('x-amzn-marketplace-token')) {
    localStorage.setItem('x-amzn-marketplace-token', decodeURIComponent(searchParams.get('x-amzn-marketplace-token')));
  }
}
